import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';



@Component({
    selector: 'app-comment-renderer',
    template: `
    <span style="text-overflow: ellipsis; white-space: nowrap !important; overflow: hidden; padding: 0;">{{ shortenedComment }}</span>
  `,
    standalone: false // NOSONAR
})
export class EventCommentRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public comment: string;
  public shortenedComment: string;
  show: boolean = false;
  trimmedComment: string;

  agInit(params: any): void {
    this.params = params;
    this.comment = params.value;
        this.trimmedComment = this.comment;
      this.shortenedComment = this.trimmedComment;
  }

  refresh(): boolean {
    return false;
  }
}
